import * as React from "react";

export const FileUplaodIcon = ({ ...props }) => {
  return (
    <svg width={12} height={12} viewBox="0 0 12 12" fill="none" {...props}>
      <path
        d="M10.75 7.5v2.167a1.083 1.083 0 01-1.083 1.083H2.083A1.083 1.083 0 011 9.667V7.5M8.583 3.708L5.874 1 3.166 3.708M5.875 1v6.5"
        stroke="#01A8CE"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
